import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FloorManagerMonthlyOverviewReport} from '../../model/report/floormanager/floor-manager-monthly-overview-report';

@Injectable({
	providedIn: 'root'
})
export class FloorManagerReportService {
	private url = 'api/report/floormanager/';

	constructor(
		private http: HttpClient
	) {}

	getMonthlyOverview(month: number): Observable<FloorManagerMonthlyOverviewReport> {
		const params = new HttpParams().set('month', String(month));
		return this.http.get<FloorManagerMonthlyOverviewReport>(`${this.url}month`, {params});
	}
}
